<app-closeable-dialog-title
  [title]="paper.title">
</app-closeable-dialog-title>

<mat-dialog-content>
  <mat-card class="research-paper-card">
    <mat-card-content>
      <div class="info">
        <mat-icon>menu_book</mat-icon>
        <span>{{ paper.venue }} - {{ paper.year }} </span>
      </div>

      <div class="info">
        <mat-icon>lightbulb</mat-icon>
        <span> <b>{{ paper.citationCount || 0 }}</b> Citations</span>
        <span> <b>{{ paper.referenceCount || 0 }}</b> References</span>
      </div>

      <div class="info">
        <mat-icon>group</mat-icon>
        <span>{{ paper.authors }}</span>
      </div>

    </mat-card-content>
  </mat-card>

  <div class="content">
    <p class="abstract-text">
      @if (paper.abstractText) {
        <h3>Abstract tvext</h3>
        {{ paper.abstractText }}
      } @else {
        No abstract available
      }
    </p>
  </div>
</mat-dialog-content>
